// export const gateKey = '';
export const gateKey = '';
export const recaptchaKey = '6LdKIrgZAAAAAFCgNLBhpQNO_a29D30zbLGQx9mb';
export const apiUrl = 'https://api-movimenta.encontrodigital.com.br';
export const apiSocket = 'https://socket.encontrodigital.com.br/';
// export const apiSocket = 'http://localhost:8001';
 //export const apiUrl = 'http://localhost:8000';
export const urlWebsite = 'https://movimentasebrae.encontrodigital.com.br';

export const home = 'Home';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'Movimenta';
export const logo = '/assets/evento/logo.png';
export const background = '/assets/evento/Fundo.jpeg';
export const authTitle = 'movimenta';
export const hash = 'e4582747-e613-424e-ab2b-b897889a1ba6';
export const social = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  linkedin: '',
  youtube: '',
  twitter: '',
};

export const dadosOrganizacao = `Sebrae, CNPJ 87.112.736/0001-30, rua sete de setembro, 555 CEP 90010-190`;

export const defaultTheme = {
  lightColor: '#fff',
  darkColor: '#333',
  defaultBackground: '#0D3E64',
  defaultColor: '#333',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: 'none',
    backgroundSticky: '#0D3E64',
    backgroundMobile: '#0D3E64',
    mobileColor: '#fff',
    color: '#fff',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};
